import script from "./CCHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CCHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CCHeader.vue?vue&type=style&index=0&id=5cb76119&scoped=true&lang=less"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb76119"]])

export default __exports__